import styled from 'styled-components';
    
const SpaceInfoMatch = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 40%;
    height: 100%;
    padding: 0 10px;
`;

const BoxBeltImg = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;

    & .belt-img {
        width: 100%;
        max-height: 20px;
        object-fit: contain;
        object-position: top;
        margin: 5px 0;
    }
    
`;

function SpaceInfoMatchComponent({ matchInfo }) {
    return (
        <SpaceInfoMatch className='space-info-match'>
            <h2 className='ppv-name'>{matchInfo.ppv.ppv_description.name} {matchInfo.ppv.date.split('-')[2]}</h2>
            <h2 className='type-match'>{matchInfo.type_match.name}</h2>
            {matchInfo.belt && (
                <BoxBeltImg className='box-belt-img'>
                    <img 
                        className='belt-img' 
                        src={process.env.REACT_APP_STORAGE_URL + matchInfo.belt.img_path} 
                        alt={matchInfo.belt.name} 
                        title={matchInfo.belt.name}
                    />
                    <h2 className='belt-name'>{matchInfo.belt.name}</h2>
                </BoxBeltImg>
            )}
        </SpaceInfoMatch>
    )
}

export default SpaceInfoMatchComponent;